import React from 'react'

import { Select } from '@fourthwall/components'

import { useReportType } from '../../../../hooks/useReportType'
import { useAnalyticsParams } from '../../hooks/useAnalyticsParams'
import * as S from './IntervalSelect.styled'

export const IntervalSelect = () => {
  const { reportType } = useReportType()
  const {
    queryParams: {
      intervals: [intervalsParam, setIntervalsParam],
    },
  } = useAnalyticsParams()

  if (reportType !== 'memberships-members-change' && reportType !== 'memberships-total-members') {
    return
  }

  return (
    <S.Container>
      <Select
        label="Type"
        options={[
          { label: 'All', value: 'ALL' },
          { label: 'Month', value: 'Month' },
          { label: 'Annual', value: 'Year' },
        ]}
        size="medium"
        value={intervalsParam || 'ALL'}
        onValueChange={(value) => setIntervalsParam(value as typeof intervalsParam)}
      />
    </S.Container>
  )
}
